// @flow
import api, { buildHeaders } from 'common/services/api';
import { BroadcastMonth } from 'broadcastCalendar/BroadcastMonth';
import CampaignsInvoice from '../domain/RadioCampaignInvoice';
import Invoices from '../domain/Invoices';

class InvoicingAPI {

  async getCampaignsInvoices(token: string, month: BroadcastMonth): Invoices {
    const url = '/statsradio/invoicing/invoices';
    const { data } = await api.get(url, asParams(month), { headers: buildHeaders(token) });

    return Invoices.parse(data);
  }

  async markInvoiceAsBilled(token: string, invoice: CampaignsInvoice, billed: boolean) {
    const url = `/statsradio/invoicing/invoices/${invoice.radio}/${invoice.month.toISO()}/billed`;

    const params = {
      billed,
    };

    await api.post(url, params, { headers: buildHeaders(token) });
  }
}

function asParams(month: BroadcastMonth) {
  return {
    broadcastMonth: month.toISO(),
  };
}

export default new InvoicingAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/services/InvoicingAPI.js